var map = {
	"./1.png": "009a",
	"./2-center-grey.png": "39ff",
	"./2-center.png": "61b9",
	"./2-down.png": "8049",
	"./2-right-grey.png": "40f0",
	"./2-up.png": "3fad",
	"./2.png": "6dba",
	"./3-center-red.png": "5dc4",
	"./3-center.png": "5336",
	"./3-down.png": "1600",
	"./3-right-red.png": "4f76",
	"./3-up.png": "fb9b",
	"./3.png": "ea16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c37e";